import SignupComponent from '@/views/Signup.vue';
import RouteNames from '../constants/route-names';

const SignUpRoute = {
  component: SignupComponent,
  name: RouteNames.Signup,
  path: '/signup',
  props: route => ({
    reDirRouteName: route.query.reDirRouteName,
    existingQueryParams: route.query.existingQueryParams,
    accountType: route.query.accountType,
  }),
};

export default SignUpRoute;
